import { BaseInput } from '@app/components/common/inputs/BaseInput/BaseInput';
import { BaseSelect } from '@app/components/common/selects/BaseSelect/BaseSelect';
import { DropdownOption } from '@app/models/DropdownOption';
import { Row, Col, Form } from 'antd';

type CustomerInfoProps = {
  mode: 'view' | 'edit' | 'create';
  statusOptions: DropdownOption[];
  customerTypeOptions: DropdownOption[];
  setIsRegularCustomer: (value: boolean) => void;
};
export const CustomerInfo: React.FC<CustomerInfoProps> = (props) => {
  const readOnly = props.mode == 'view';
  const requiredMark = !readOnly;
  return (
    <>
      <Row gutter={16}>
        <Col xs={24} md={24} lg={12}>
          <Form.Item name="status" label="Status" rules={[{ required: requiredMark }]}>
            {readOnly ? (
              <BaseInput readOnly={readOnly} />
            ) : (
              // eslint-disable-next-line @typescript-eslint/no-empty-function
              <BaseSelect options={props.statusOptions} onChange={() => {}}></BaseSelect>
            )}
          </Form.Item>
        </Col>
        <Col xs={24} md={24} lg={12}>
          <Form.Item name="customer_type" label="Customer Type" rules={[{ required: requiredMark }]}>
            {readOnly ? (
              <BaseInput readOnly={readOnly} />
            ) : (
              <BaseSelect
                options={props.customerTypeOptions}
                onChange={(e) => {
                  console.log(e == 'REGULAR');
                  props.setIsRegularCustomer(e == 'REGULAR');
                }}
              ></BaseSelect>
            )}
          </Form.Item>
        </Col>
        <Col xs={24} md={24} lg={12}>
          <Form.Item name="first_name" label="First Name" rules={[{ required: requiredMark }]}>
            <BaseInput readOnly={readOnly} />
          </Form.Item>
        </Col>
        <Col xs={24} md={24} lg={12}>
          <Form.Item name="last_name" label="Last Name" rules={[{ required: requiredMark }]}>
            <BaseInput readOnly={readOnly} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} md={24} lg={12}>
          <Form.Item name="username" label="Username" rules={[{ required: requiredMark }]}>
            <BaseInput readOnly={readOnly} />
          </Form.Item>
        </Col>
        <Col xs={24} md={24} lg={12}>
          <Form.Item name="email" label="Email" rules={[{ required: requiredMark, type: 'email' }]}>
            <BaseInput readOnly={readOnly} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} md={24} lg={12}>
          <Form.Item name="contact_no" label="Contact No" rules={[{ required: requiredMark }]}>
            <BaseInput readOnly={readOnly} />
          </Form.Item>
        </Col>
        <Col xs={24} md={24} lg={12}>
          <Form.Item name="dob" label="Date of Birth" rules={[{ required: requiredMark }]}>
            <BaseInput readOnly={readOnly} type="date" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} md={24} lg={12}>
          <Form.Item name="address" label="Address" rules={[{ required: requiredMark }]}>
            <BaseInput readOnly={readOnly} />
          </Form.Item>
        </Col>
        <Col xs={24} md={24} lg={12}>
          <Form.Item name="nic" label="NIC" rules={[{ required: requiredMark }]}>
            <BaseInput readOnly={readOnly} />
          </Form.Item>
        </Col>

        {/* <Col xs={24} md={24} lg={12}>
          <Form.Item name="verified" label="Verified" rules={[{ required: requiredMark }]}>
            <BaseInput readOnly={true} />
          </Form.Item>

        </Col> */}
      </Row>
    </>
  );
};
